import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { useFieldLayout } from '../hooks/useMedia';
import { ReimbursementComponent } from '../modules/ReimbursementLog/components/Reimbursement';
import { ReimbursementsPhone } from '../modules/ReimbursementLog/phone/ReimbursementsPhone';

export const Route = createFileRoute('/reimbursements/$reimbursementOwnerId')({
  component: RouteComponent,
  params: z.object({
    reimbursementOwnerId: z.coerce.number().positive(),
  }),
  // Phones and tablets open a reimbursement as a page: in the URL, so a refresh keeps it and the
  // phone's Back steps out. Desktop doesn't read it.
  validateSearch: z.object({
    reimbursement: z.coerce.number().int().positive().optional(),
  }),
});

function RouteComponent() {
  const { reimbursementOwnerId } = Route.useParams();
  // The switch lives here only, so the Payroll and Employees embeds of the log stay desktop.
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) return <ReimbursementsPhone reimbursementOwnerId={reimbursementOwnerId} />;
  return <ReimbursementComponent reimbursementOwnerId={reimbursementOwnerId} />;
}
